export default {
    label_task:{
        en:"Varieties",
        bn:'ব্যবহারকারীরা'
    },
    label_new_task:{
        en:"New Variety",
        bn:'নতুন ব্যবহারকারী'
    },
    label_edit_task:{
        en:"Edit Variety",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    label_details_task:{
        en:"Details of Variety",
        bn:'ব্যবহারকারীর বিবরণ'
    },
    label_crop_id:{
        en:"Crop",
        bn:"কর্মচারী আইডি"
    },
    label_crop_name:{
        en:"Crop",
        bn:"কর্মচারী আইডি"
    },
    label_whose :{
        en:"Whose Variety",
        bn:"কর্মচারী আইডি"
    },
    label_principal_id  :{
        en:"Principal",
        bn:"কর্মচারী আইডি"
    },
    label_principal_name  :{
        en:"Principal",
        bn:"কর্মচারী আইডি"
    },
    label_competitor_id  :{
        en:"Competitor",
        bn:"কর্মচারী আইডি"
    },
    label_competitor_name  :{
        en:"Competitor",
        bn:"কর্মচারী আইডি"
    },
    label_retrial  :{
        en:"Retrial",
        bn:"কর্মচারী আইডি"
    },
    label_crop_feature_ids:{
        en:"Features",
        bn:"কর্মচারী আইডি"
    },
    label_crop_type_id:{
        en:"Type",
        bn:"কর্মচারী আইডি"
    },
    label_crop_type_name:{
        en:"Type",
        bn:"কর্মচারী আইডি"
    },

}